// @flow

import React from "react";
import {
  Grid,
  Card,
  Table,
  Page,
  colors,
  Tooltip,
  Tag,
  Form,
  Button,
} from "tabler-react";
import Select from "react-select";
import Moment from "moment";
import Slider from "react-slick";

import "tabler-react/dist/Tabler.css";
import C3Chart from "react-c3js";
import { Link, withRouter, browserHistory } from "react-router-dom";
import { connect } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import { toast, ToastContainer } from "react-toastify";
import { getSocket, safeEmit } from "../services/socket.service";

import SiteWrapperAdmin from "./SiteWrapper.admin.react";
import authActions from "../redux/auth/action";
import clientService from "../services/client";
import ReadmorePopup from "./Readmore";
import InfoPopup from "./InfoPopup";
import "./slick/slick.css";
import "./slick/slick-theme.css";
import { changeLanguage } from "../../src/language/index";
import botService from "../services/bot";
import BotEdit from "./bots/BotEdit";
import loginService from "../services/user";

var { jwtToken } = localStorage;
// var ENDPOINT = "https://waagentportal.rpsapi.in";
var ENDPOINT = process.env.REACT_APP_baseUrl;
// var socket;
var audio;

class AdminDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.chatDiv = React.createRef();
    this.state = {
      messageText: "",
      currentPage: this.props.match.params.page,
      nextPage: false,
      userStatus: props.user.status,
      totalRecords: 0,
      chatUsers: [],
      buttons: [],
      messages: [],
      selectChatUser: null,
      selectedFile: "",
      formDisabled: false,
      files: [],
      openPopup: false,
      openInfoPopup: false,
      page: 1,
      juniorPage: 0,
      juniorChatIdGet: false,
      engageNumber: 0,
      search: "",
      escalationReason: "",
      selectChatUserForEscalation: null,
      teaBreakStatus: false,
      loadingChats: false, //
    };
    console.log(this.props.user);
    audio = new Audio("https://waportal.rpsapi.in/notification_tune.mp3");
    this.handleChange = this.handleChange.bind(this);
    this.onChangeFile = this.onChangeFile.bind(this);
    this.closePopup = this.closePopup.bind(this);
    this.closeInfoPopup = this.closeInfoPopup.bind(this);
    // this.changeLanguage = this.changeLanguage.bind(this);
  }
  styles = {
    modalWrapper: {
      display: "none",
    },
    modal: {
      width: "50%",
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      background: "#ffffff",
      boxShadow: "0 28px 48px rgba(0, 0, 0, 0.4)",
      zIndex: "12",
    },
    TeaBreakWrapper: {
      width: "100vw",
      height: "100vh",
      position: "fixed",
      top: "0",
      left: "0",
      zIndex: "11",
    },
    TeaBreakBackgroundBlur: {
      background: "#000000",
      width: "100%",
      height: "100%",
      opacity: "0.5",
    },
    TeaBreakButton: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%,-50%)",
      fontSize: "1rem",
    },
  };

  closePopup(data) {
    this.setState({
      openPopup: {
        open: false,
        data: false,
      },
    });
  }

  closeInfoPopup(data) {
    this.setState({
      openInfoPopup: {
        open: false,
        data: false,
      },
    });
  }

  openInfoPopup(e, data) {
    console.log("DATADATA", data);
    let arr = data.entity;
    if (!arr) arr = [];
    // remove otp
    arr = arr.filter((el) => el.entity != "otp");

    if (data.prescription)
      arr.push({ entity: "prescription", value: data.prescription });
    if (data.patientCode)
      arr.push({ entity: "patient code", value: data.patientCode });
    if (data.fallback_1)
      arr.push({ entity: "Fallback 1", value: data.fallback_1 });
    if (data.fallback_2)
      arr.push({ entity: "Fallback 2", value: data.fallback_2 });

    this.setState({
      openInfoPopup: {
        open: true,
        data: arr,
      },
    });
    // this.setState({
    //   openInfoPopup: {
    //     open: true,
    //     data: data,
    //   },
    // });
  }

  openPopup(e, data) {
    this.setState({
      openPopup: {
        open: true,
        data: data,
      },
    });
  }

  handleChange = (e, field) => {
    console.log(e.keyCode);
    const val = e.target.value;
    this.setState({ messageText: val });
    if (e.keyCode == 13 && e.shiftKey == false) {
      this.emitMessage(e);
    }
  };

  componentWillMount() {
    this.unlisten = this.props.history.listen((location, action) => {
      let url = location.pathname.split("/");

      if (url != undefined && url[4] != undefined) {
        this.setState({
          clientId: url[4],
        });
        this.getChatUsers(1, this.state.search, url[4]);
        this.getMessages();
      }
    });

    botService
      .getButtons()
      .then((res) => {
        if (res.statusCode === 200) {
          this.setState(() => ({
            buttons: res.data.result,
          }));
          // this.setLoadingToggle(false);
        }
      })
      .catch((error) => {
        // this.setLoadingToggle(false);
      });
  }

  async componentDidMount() {
    console.log(this.props, "PROPS");
    const hrefSplit = window.location.href.split('?');
    console.log(hrefSplit);
    if (hrefSplit.length > 1) {
      window.location.href = hrefSplit[0];
    }

    console.log("componentWillMount");
    document.title = "Voiceoc | Chat";
    //this.detectChnageURl();

    this.getChatUsers(1, this.state.search, this.props.user._id);
    try {
      const socket = getSocket(); // ✅ use getSocket from socket.service.js
      if (!socket) return;
  
      if (!socket.connected && this.props.match.params.userId === undefined) {
        await new Promise(resolve => socket.once('connect', resolve));
        console.log("✅ Connected to socket");
      }
  
      socket.on("chatting", (data) => {
        console.log("📥 chatting event received:", data);
  
        switch (data.event) {
          case 'receive-message':
            audio.play();
            window.focus();
            new Notification('New Notification received');
            this.getChatUsers(this.props.match.params.page, this.state.search, this.props.user._id, true);
            break;
  
          case 'initiate-chat':
          case 'end-chat':
            audio.play();
            this.getChatUsers(this.props.match.params.page, this.state.search, this.props.user._id, true);
            this.engageNumberApi();
            break;
  
  
          default:
            console.warn("⚠️ Unknown event type:", data.event);
        }
      });
  
      this.engageNumberApi(); // Initialize engage number
    } catch (error) {
      console.error("❌ Error initializing socket:", error);
    }

    setInterval(() => {
      try {
        
     
      let localStorageData = localStorage.getItem("current-session");
      if (!localStorageData) localStorageData = JSON.stringify(new Date());

      let currentSession = new Date(JSON.parse(localStorageData));
      currentSession.setMinutes(
        currentSession.getMinutes() +
          this.props.user.settingData.sessionTime / 1000,
      );
      if (
        currentSession.getTime() - new Date().getTime() <
        this.props.user.settingData.sessionTime / 1000
      ) {
        loginService
          .logout()
          .then((response) => {
            console.log(response);
            console.log(response.statusCode);
            if (response.statusCode === 200) {
              this.props.logOut();
              localStorage.removeItem("persist:voiceoc");
              localStorage.removeItem("current-session");
              this.props.history.push("/login");
            } else if (response.statusCode === 201) {
              this.props.logOut();
              localStorage.removeItem("persist:voiceoc");
              localStorage.removeItem("current-session");
              this.props.history.push("/login");
            } else {
              toast.error(response.data.message);
            }
            //this.setLoadingToggle(false);
          })
          .catch((err) => {
            console.log(err);
            this.props.logOut();
            this.props.history.push("/login");
            //this.setLoadingToggle(false);
          });
      } else {
        console.log("session in");
      }
     } catch (error) {
       console.error("❌ Error during session check:", error);
     }
   }, 30000);
  }

  async engageNumberApi() {
    let engageData = await clientService.getCount();
    console.log("engageData ", engageData);
    this.setState({
      teaBreakStatus: engageData.data.status === "break" ? true : false,
      engageNumber: engageData.data.engageNumbers,
    });
  }
  handleScroll(event) {
    let self = this;
    if (event.target.scrollTop === 0) {
      if (!this.state.juniorChatIdGet) {
        let activePage = this.state.page + parseInt(1);
        this.getMessages(activePage);
      } else {
        let activePage = this.state.juniorPage + parseInt(1);
        this.getMessages(activePage);
      }
      //console.log('abc',event.target.scrollTop)
    }
  }

  getFilterChatUser() {
    const id = this.props.match.params.userId;
    console.log("`````````````````````````````> ", id);
    var chatUser = this.state.chatUsers.filter(function (user) {
      if (user.customerDetail.length) {
        return user.customerDetail[0]._id === id;
      }
    });
    console.log(chatUser);
    if (chatUser.length) {
      let formDisabled = false;
      if (
        chatUser &&
        chatUser[0].status &&
        (chatUser[0].status === "deactive" ||
          (chatUser[0].customerDetail[0].escalated &&
            this.props.user.agentCategory === "junior"))
      ) {
        formDisabled = true;
      }
      this.setState({
        selectChatUser: chatUser[0],
        formDisabled,
      });
    }
    return "";
  }

  getJuniorMessages(page) {
    // get previous junior messages in senior chat
    let objWithJuniorChatId = this.state.messages.find((el) => el.juniorchatId);
    if (objWithJuniorChatId) {
      let chatId = objWithJuniorChatId.juniorchatId;
      console.log("JUNIORCHATID", chatId);

      clientService.getMessages(chatId, page).then((res) => {
        console.log("GET MESSAGES", res);
        if (res.statusCode === 200) {
          if (res.data.result && res.data.result.length) {
            var allMessage = res.data.result
              .reverse()
              .concat(this.state.messages);
            this.setState(() => ({
              messages: allMessage,
              juniorPage: page,
            }));
          }

          // if (page === 1) {
          //   this.setState(() => ({
          //     messages: res.data.result,
          //     juniorPage: 1,
          //   }));
          //   this.scrollToBottom();
          // }
          if (res.data.result && res.data.result.length) {
            this.chatDiv.current.scrollTop = 100;
          }
        }
      });
    }
  }


    // Smooth scroll helper
  smoothScrollTo(element, to, duration = 400) {
    if (!element) return;
    const start = element.scrollTop;
    const change = to - start;
    const startTime = performance.now();

    function animateScroll(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      element.scrollTop = start + change * progress;
      if (progress < 1) {
        requestAnimationFrame(animateScroll);
      }
    }
    requestAnimationFrame(animateScroll);
  }

  getMessages(page = 1) {
    if (this.state.selectChatUser) {
      let chatId = this.state.selectChatUser._id;
      console.log(this.state.selectChatUser);
      console.log(
        "MSG",
        this.state.messages,
        this.state.selectChatUser.customerDetail[0].mobileNumber,
      );
      // if (this.state.juniorChatIdGet && this.state.messages && this.state.messages[0]) {
      //   this.getJuniorMessages(page)
      // }
      // else {
      let juniorChatId = null;
      let objWithJuniorChatId = this.state.messages.find(
        (el) => el.juniorchatId,
      );
      if (objWithJuniorChatId && this.props.user.agentCategory != "junior")
        juniorChatId = objWithJuniorChatId.juniorchatId;

      // console.log('this.state.selectChatUser',this.state.selectChatUser)
      // return false;

      console.log(this.state.selectChatUser, "ChatUser");

      if (
        this.state.selectChatUser.customerDetail &&
        this.state.selectChatUser.customerDetail.length &&
        this.state.selectChatUser.customerDetail[0].mobileNumber
      ) {
        clientService
          .getAllMessages(
            this.state.selectChatUser.customerDetail[0].mobileNumber,
            page,
          )
          .then(async (res) => {
            if (res.statusCode === 200) {
              if (res.data.result && res.data.result.length) {
                var allMessage = res.data.result
                  .reverse()
                  .concat(this.state.messages);

                await this.setState(() => ({
                  messages: allMessage,
                  page: page,
                }));
              }
              if (page === 1) {
                await this.setState(() => ({
                  messages: res.data.result,
                  page: 1,
                }));
                this.scrollToBottom();
              }

              if (page > 1 && res.data.result && res.data.result.length) {
                this.smoothScrollTo(this.chatDiv.current, 100, 400);
              }
            }
          })
          .catch((err) => console.error(err));
      } else {
        clientService.getMessages(chatId, page, juniorChatId).then((res) => {
          console.log("GET MESSAGES", res);
          if (res.statusCode === 200) {
            if (res.data.result && res.data.result.length) {
              let objWithJuniorChatId = res.data.result.find(
                (el) => el.juniorchatId,
              );
              if (page === 1) {
                if (
                  objWithJuniorChatId &&
                  this.props.user.agentCategory != "junior"
                ) {
                  let tempJuniorChatId = objWithJuniorChatId.juniorchatId;
                  clientService
                    .getMessages(chatId, page, tempJuniorChatId)
                    .then((res) => {
                      console.log("GET MESSAGES", res);
                      if (res.statusCode === 200) {
                        if (res.data.result && res.data.result.length) {
                          this.setState(() => ({
                            messages: res.data.result.reverse(),
                            page: 1,
                          }));
                          this.scrollToBottom();
                        }
                      }
                    });
                } else {
                  this.setState(() => ({
                    messages: res.data.result.reverse(),
                    page: 1,
                  }));
                  this.scrollToBottom();
                }
              }
              if (page > 1 && res.data.result && res.data.result.length) {
                var allMessage = res.data.result
                  .reverse()
                  .concat(this.state.messages);
                this.setState(() => ({
                  messages: allMessage,
                  page: page,
                }));
                this.smoothScrollTo(this.chatDiv.current, 100, 400);
              }

              // if (res.data.result.length < 10) {
              //   this.setState({ juniorChatIdGet: true })
              // }
            }
            // else if (res.data.result && !res.data.result.length) {
            //   this.setState({ juniorChatIdGet: true })
            //   this.getJuniorMessages(1)
          }

          // }
        });
        // }
      }
    }
  }

  scrollToBottom = () => {
    if (this.chatDiv.current) {
      this.chatDiv.current.scrollTop = this.chatDiv.current.scrollHeight;
    }
  };

  getChatUsers(
    page,
    search,
    clientId,
    highlited = false,
    sortKey = false,
    sortType = false,
  ) {

    this.setState({ loadingChats: true }); 
    clientService
      .getChatUsers(page, search, 10, false, sortKey, sortType)
      .then((res) => {
        console.log("");
        if (res.statusCode === 200) {
          let dataArray = res.data.result;
          if (highlited && dataArray.length > 0) {
            dataArray[0]["highlited"] = true;
          }
          this.setState(() => ({
            chatUsers: res.data.result,
            nextPage: res.data.next,
            totalRecords: res.data.total,
            prevoiusPage: this.state.currentPage > 1 ? true : false,
             loadingChats: false, 
          }));
          this.getFilterChatUser();
          if (
            this.props.match.params &&
            this.props.match.params.userId != undefined
          ) {
            this.getMessages();
          }
          this.setState({ loadingChats: false });
        }
      })
      .catch((error) => {
        this.setState({ loadingChats: false });
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.statusCode === 201
        ) {
          this.props.logOut();
          this.props.history.push("/login");
        }
        console.log(error);
         this.setState({ loadingChats: false }); // hide loader on error
      });
  }

  getFilterAdmin(id) {
    var admins = this.state.adminOptions.filter(function (admin) {
      return admin._id === id;
    });
    if (admins.length) {
      return admins[0];
    }
    return "";
  }

  detectChnageURl() {
    if (this.props.match.params && this.props.match.params.id != undefined) {
      let label = this.getFilterAdmin(this.props.match.params.id);
      this.setState({
        selectedAdmin: { value: label._id, label: label.name },
      });
    }

    if (
      this.props.match.params &&
      this.props.match.params.clientId != undefined
    ) {
      this.setState({
        clientId: this.props.match.params.clientId,
      });
    }
  }

  //listen client change
  selectAdmin = (selectedAdmin) => {
    this.props.history.push("/admin/dashboard/" + selectedAdmin.value + "/1");
  };

  formatDate(date) {
    return Moment(date).format("DD/MM/YY h:mm a");
  }

  getPagination() {
    var startRecord =
      this.props.match.params.page == 1
        ? this.props.match.params.page
        : 10 * (this.props.match.params.page - 1) + 1;
    var endRecord =
      parseInt(startRecord) + parseInt(this.state.chatUsers.length) - 1;
    return startRecord + "-" + endRecord;
    //+' of '+this.state.totalRecords;
  }

  selectUserToChat(e, user) {
    // if (this.state.formDisabled) {
    //   return;
    // }
    this.props.history.push("/agent/dashboard/1/" + user._id);
  }

  async uploadFile() {
    let filesData;
    clientService
      .uploadFile(this.state.selectedFile)
      .then((response) => {
        const filesData = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
    return filesData;
  }

  async emitMessage(event) {

    event.preventDefault();
    if (!this.state.selectChatUser) {
      toast.success("Please first select the user.");
      return false;
    }
    let customerDetail = this.state.selectChatUser.customerDetail[0];
    let emitData = {
      event: "send-message",
      data: {
        chatId: this.state.selectChatUser._id,
        mobileNumber: this.state.selectChatUser.customerDetail[0].mobileNumber,
        body: this.state.messageText,
        media: [],
        customerDetail,
      },
    };
    if (this.state.selectedFile) {
      clientService
        .uploadFile(this.state.selectedFile)
        .then((response) => {
          const filesData = response.data;
          emitData.data.media.push(filesData);
          console.log(emitData);
          safeEmit("chat", emitData);
          this.setState({ messageText: "", selectedFile: null });
          document.getElementById("chatForm").reset();
          this.getChatUsers(
            this.props.match.params.page,
            this.state.search,
            this.props.user._id,
            true,
          );
          this.getMessages();
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      if (this.state.messageText == "" || this.state.messageText == null) {
        toast.error("Please Type something.");
        return false;
      }
      safeEmit("chat", emitData);
      this.setState({ messageText: "" });
      document.getElementById("chatForm").reset();
      this.getChatUsers(
        this.props.match.params.page,
        this.state.search,
        this.props.user._id,
        true,
      );
      this.getMessages();
    }
  }

  onChangeFile = (event) => {
    event.preventDefault();
    if (!this.state.selectChatUser) {
      toast.success("Please first select the user.");
      return false;
    }
    const data = new FormData();
    data.append("media", event.target.files[0]);
    this.setState({ selectedFile: data, fileName: event.target.files[0].name });
  };

  chatEnd(e, selectChatUser) {
    if (!selectChatUser) {
      toast.success("Please first select the user.");
      return false;
    }
    let chatEndData = {
      chatId: selectChatUser._id,
      mobileNumber: selectChatUser.customerDetail[0].mobileNumber,
    };

    clientService
      .endChat(chatEndData)
      .then((response) => {
        toast.success("Chat end successfully");
        this.setState({
          formDisabled: true,
        });
        this.getChatUsers(
          this.props.match.params.page,
          this.state.search,
          this.props.user._id,
        );
        this.engageNumberApi();
      })
      .catch((error) => {
        console.log(error);
      });
  }
  escalateChat(e, selectChatUser) {
    if (!selectChatUser) {
      toast.warn("Please first select the user.");
      return false;
    }
    if (this.props.user.agentCategory === "junior") {
      // clientService
      //   .switchToSeniorChat(pstBody)
      //   .then((response) => {
      //     toast.success("Escalate chat successfully.");
      //     this.setState({
      //       formDisabled: true,
      //     });
      //     this.getChatUsers(
      //       this.props.match.params.page,
      //       this.state.search,
      //       this.props.user._id
      //     );
      //     this.engageNumberApi();
      //   })
      //   .catch((error) => {
      //     console.log(error);
      //   });

      this.setState({
        selectChatUserForEscalation: {
          ...selectChatUser,
          chatObj: this.state.messages[0],
        },
      });
      this.openModal();
    }
  }
  closeModal() {
    this.setState({ escalationReason: "" });
    document.getElementsByClassName("BackgroundBlur")[0].style.display = "none";
  }
  openModal() {
    document.getElementsByClassName("BackgroundBlur")[0].style.display =
      "block";
  }
  handleChangeEscalationReason(e) {
    this.setState({ escalationReason: e.target.value });
  }
  SendEscalationReason() {
    console.log(this.state.selectChatUserForEscalation, "chat Obj");
    if (this.state.escalationReason !== "") {
      const postBody = {
        mobileNumber:
          this.state.selectChatUserForEscalation.customerDetail[0].mobileNumber,
        chatId: this.state.selectChatUserForEscalation._id,
        escalationReason: this.state.escalationReason,
      };
      console.log("QWERTYUIOP", postBody);
      clientService
        .switchToSeniorChat(postBody)
        .then((response) => {
          if (response.data.message == "NO Senior Is Available") {
            toast.error("NO Senior Is Available");
          } else {
            console.log("QWERTYUIOP RESPONSE", response);
            toast.success("Escalate chat successfully.");
            this.setState({
              formDisabled: true,
            });
            this.getChatUsers(
              this.props.match.params.page,
              this.state.search,
              this.props.user._id,
            );
            this.engageNumberApi();
            this.closeModal();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  onEnterPress = (e) => {
    if (e.keyCode == 13 && e.shiftKey == false) {
      e.preventDefault();
      console.log(e.keyCode, e.shiftKey, "eeeeeee");
    }
  };

  pagination(e, page) {
    // this.callService(page);
    console.log("called 12");
    this.getChatUsers(page, this.state.search, false, false);
    this.props.history.push("/agent/dashboard/" + page);
  }

  orderByChatList(e) {
    if (e.target.value === "latest") {
      this.getChatUsers(1, this.state.search, false, false);
    } else {
      var valueKey = e.target.value.split("_");
      this.getChatUsers(
        1,
        this.state.search,
        false,
        false,
        valueKey[1],
        valueKey[0],
      );
    }
  }

  getButtonData = (data) => {
    console.log("data==", data);
    this.setState({ messageText: data });
  };

  async handleSearch(event) {
    await this.setState({
      search: event.target.value,
    });
    this.getChatUsers(
      this.props.match.params.page,
      this.state.search,
      false,
      false,
    );
    // this.props.history.push("/admin/all-chat/" + 1);
  }
  TeaBreakToggle() {
    let body = {
      name: this.props.user.name,
      email: this.props.user.email,
      // category: "customerSupportTeam",
      agentId: this.props.user.agentId,
      language: this.props.user.language,
      agentType: this.props.user.agentType,
      status: this.props.user.status,
      isSticky: this.props.user.isSticky,
      // role: this.props.user.role,
    };

    if (this.state.teaBreakStatus) {
      body.status = "active";
      clientService.toggleTeaBreak(this.props.user._id, body).then((res) => {
        console.log(res);
        this.setState({ teaBreakStatus: false });
      });
    } else {
      body.status = "break";
      clientService.toggleTeaBreak(this.props.user._id, body).then((res) => {
        console.log(res);
        this.setState({ teaBreakStatus: true });
      });
    }
  }

  render() {
    const { selectChatUser } = this.state;
    const { nextPage } = this.state;
    const { chatUsers } = this.state;
    const { messages } = this.state;
    const { messageText } = this.state;
    const { buttons } = this.state;
    console.log("buttons", buttons);
    let settings = {
      dots: true,
      autoplay: false,
      infinite: true,
      speed: 500,
      slidesToShow: buttons.length < 4 ? buttons.length : 4,
      slidesToScroll: 1,
    };

    return (
      <>
        <SiteWrapperAdmin>
          <Page.Content>
            <audio id="audio">
              <source src="/notification_tune.mp3" type="audio/mp3"></source>
            </audio>

            <div>
              <Grid.Row>
                <div className="page-header">
                  <div className="col col-sm-12 row disableFlexWrap ascv">
                    <div className="d-flex col-sm-4">
                      <select
                        className=" custom-select    "
                        onChange={(e) => this.orderByChatList(e)}
                      >
                        <option value="latest">
                          {changeLanguage(
                            this.props.siteLanguage,
                            "time_latest_first",
                          )}
                        </option>
                        <option value="asc_name">
                          {changeLanguage(this.props.siteLanguage, "name_a_z")}
                        </option>
                        <option value="desc_name">
                          {changeLanguage(this.props.siteLanguage, "name_z_a")}
                        </option>
                      </select>
                    </div>

                    <div className="col col-sm-4 ">
                      <div className="form-control">
                        Active Chats : {` ${this.state.engageNumber}`}
                      </div>
                    </div>

                    <div className="col col-sm-4 engage-bo ">
                      <input
                        name="search"
                        className="form-control"
                        type="text"
                        placeholder="Search"
                        value={this.state.search}
                        onChange={(e) => this.handleSearch(e)}
                      />
                    </div>
                    <div className="col col-sm-4 ">
                      <button
                        className="btn btn-primary"
                        onClick={() => this.TeaBreakToggle()}
                      >
                        Tea Break
                      </button>
                    </div>
                  </div>
                </div>
              </Grid.Row>
              {/* <Grid.Row>
           
            </Grid.Row> */}
              <Grid.Row>
                <div className="col col-sm-6 tableMargin">
                  {/* //display button col-sm-5 */}

                  <Card className="card01a">
                    <Table
                      cards={true}
                      striped={true}
                      responsive={true}
                      className="table-vcenter  tablebackground"
                    >
                      <Table.Header>
                        <Table.Row>
                          <Table.ColHeader className="capitilize fontSize">
                            {" "}
                          </Table.ColHeader>

                          <Table.ColHeader className="capitilize fontSize aligntd">
                            {" "}
                            {changeLanguage(this.props.siteLanguage, "name")}
                          </Table.ColHeader>
                          <Table.ColHeader className="capitilize fontSize aligntd">
                            {changeLanguage(this.props.siteLanguage, "date")}
                          </Table.ColHeader>
                          <Table.ColHeader className="capitilize fontSize aligntd">
                            {changeLanguage(
                              this.props.siteLanguage,
                              "mobile_number",
                            )}
                          </Table.ColHeader>

                          {/* <Table.ColHeader className="capitilize fontSize">
                          Context{" "}
                        </Table.ColHeader>
                        <Table.ColHeader className="capitilize fontSize">
                          Hospital{" "}
                        </Table.ColHeader> */}
                          {/* <Table.ColHeader className="capitilize fontSize">City</Table.ColHeader> */}
                          <Table.ColHeader className="capitilize fontSize">
                            Context
                          </Table.ColHeader>

                          <Table.ColHeader className="capitilize fontSize"></Table.ColHeader>
                        </Table.Row>
                      </Table.Header>
                      <Table.Body>
                        {chatUsers.length ? (
                          chatUsers.map((user, childIndex) => (
                            <tr
                              key={childIndex}
                              className={
                                "" +
                                (selectChatUser &&
                                user.customerId === selectChatUser.customerId
                                  ? "highlitedtr"
                                  : "") +
                                (user.status === "active" ? " boldtd" : "") +
                                " "
                              }
                            >
                              <td className="w-1 sticky-col">
                                {user.highlited ? (
                                  <span className="avatar1"></span>
                                ) : null}
                              </td>
                              <td
                                className="cursorPointer sticky-col aligntd"
                                onClick={(e) =>
                                  user &&
                                  user.customerDetail &&
                                  user.customerDetail.length &&
                                  this.selectUserToChat(
                                    e,
                                    user.customerDetail[0],
                                  )
                                }
                              >
                                {user.status === "active" ? (
                                  <span>
                                    {user &&
                                      user.customerDetail &&
                                      user.customerDetail.length > 0 &&
                                      user.customerDetail[0].name}
                                    {/* {user._id} */}

                                    {/* <pre>
                                        {JSON.stringify(user,null,2)}
                                      </pre> */}
                                  </span>
                                ) : (
                                  <span>
                                    {user &&
                                      user.customerDetail &&
                                      user.customerDetail.length > 0 &&
                                      user.customerDetail[0].name}
                                    {/* {user._id} */}
                                  </span>
                                )}
                              </td>
                              <td className="aligntd">
                                {this.formatDate(user.updatedAt)}
                              </td>

                              <td className="aligntd">
                                {user &&
                                  user.customerDetail &&
                                  user.customerDetail.length > 0 &&
                                  user.customerDetail[0].mobileNumber}
                              </td>

                              {/* <td className="">
                              {user &&
                                user.customerDetail &&
                                user.customerDetail.length > 0 &&
                                user.customerDetail[0].context}
                            </td> */}
                              {/* <td className="">
                              {user &&
                                user.customerDetail &&
                                user.customerDetail.length > 0 &&
                                user.customerDetail[0].hospital
                                  .charAt(0)
                                  .toUpperCase() +
                                  user.customerDetail[0].hospital.slice(1)}
                            </td> */}

                              {/* <td className="">
                              { user && user.customerDetail && user.customerDetail.length>0 && user.customerDetail[0].city}
                            </td> */}
                              <td className="">
                                {user &&
                                  user.customerDetail &&
                                  user.customerDetail.length > 0 &&
                                  user.customerDetail[0].context}
                              </td>

                              <td className="w-1">
                                <a
                                  className="icon"
                                  onClick={(e) =>
                                    this.openInfoPopup(
                                      e,
                                      user.customerDetail[0],
                                    )
                                  }
                                >
                                  {user.customerDetail.length > 0 &&
                                  user.customerDetail[0].entity.length > 0 ? (
                                    <i className="fe fe-info"></i>
                                  ) : null}
                                </a>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <Table.Row>
                            <Table.Col colSpan={7}>
                              Sorry! no data found.
                            </Table.Col>
                          </Table.Row>
                        )}
                      </Table.Body>
                    </Table>
                    {/* pagination */}
                    <div className="form-group" style={{ float: "right" }}>
                      <label className="form-label"></label>
                      <div className="selectgroup align-to-right paginations">
                        <span>{this.getPagination()}</span>

                        <i
                          className={
                            "fe " +
                            (this.props.match.params.page <= 1
                              ? "not-active "
                              : "cursorPointer ") +
                            " fe-chevron-left"
                          }
                          onClick={(e) =>
                            this.pagination(
                              e,
                              parseInt(this.props.match.params.page) - 1,
                            )
                          }
                          // disabled={this.props.match.params.page <= 1}
                        ></i>

                        <i
                          className={
                            "fe " +
                            (!nextPage ? "not-active " : "cursorPointer ") +
                            " fe-chevron-right"
                          }
                          onClick={(e) =>
                            this.pagination(
                              e,
                              parseInt(this.props.match.params.page) + 1,
                            )
                          }
                          // disabled={!nextPage}
                        ></i>
                      </div>
                    </div>
                  </Card>
                </div>
                {/* topChatBoc */}
                <div className="col col-sm-6 ">
                  {this.state.isLoading ? (
                    <div
                      className="card card2 d-flex align-items-center justify-content-center"
                      style={{ height: "55vh" }}
                    >
                      <img
                        src={"/images/loader.gif"}
                        height={100}
                        width={100}
                      />
                    </div>
                  ) : (
                    <div className="card card2">
                      <div className="card-header1">
                        <h3 className="card-title card-t1">
                          {selectChatUser
                            ? selectChatUser.customerDetail[0].name
                            : changeLanguage(this.props.siteLanguage, "chat")}
                        </h3>
                        <div className="card-options">
                          {this.props.user.agentCategory === "junior" && (
                            <button
                              className={
                                " bg-black marginChatBox escalateButton" +
                                (this.state.formDisabled
                                  ? " disablebutton"
                                  : " ") +
                                "" +
                                (this.state.teaBreakStatus
                                  ? " disablebutton"
                                  : " ")
                              }
                              onClick={(e) => {
                                if (
                                  window.confirm("Are you sure to escalate?")
                                ) {
                                  this.escalateChat(e, selectChatUser);
                                }
                              }}
                              disabled={
                                this.state.formDisabled ||
                                this.state.teaBreakStatus
                              }
                            >
                              {" "}
                              Escalate{" "}
                            </button>
                          )}
                          <button
                            className={
                              " bg-black marginChatBox " +
                              (this.state.formDisabled
                                ? " disablebutton"
                                : " ") +
                              "" +
                              (this.state.teaBreakStatus
                                ? " disablebutton"
                                : " ")
                            }
                            onClick={(e) => {
                              if (window.confirm("Are you sure to end chat?")) {
                                this.chatEnd(e, selectChatUser);
                              }
                            }}
                            disabled={
                              this.state.formDisabled ||
                              this.state.teaBreakStatus
                            }
                          >
                            {" "}
                            {changeLanguage(
                              this.props.siteLanguage,
                              "end_chat",
                            )}{" "}
                            {this.state.formDisabled}
                          </button>
                        </div>
                      </div>

                            {/* Loader overlay for chat history */}
                  {this.state.loadingChats && (
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        background: "rgba(255,255,255,0.7)",
                        zIndex: 20,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <div style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center"
                      }}>
                        <div className="modern-spinner" />
                        <span style={{ marginTop: 12, color: "#333", fontWeight: 500, fontSize: 16 }}>Loading chat...</span>
                      </div>
                      <style>
                        {`
                          .modern-spinner {
                            width: 48px;
                            height: 48px;
                            border: 5px solid #e0e0e0;
                            border-top: 5px solid #007bff;
                            border-radius: 50%;
                            animation: spin 1s linear infinite;
                          }
                          @keyframes spin {
                            0% { transform: rotate(0deg);}
                            100% { transform: rotate(360deg);}
                          }
                        `}
                      </style>
                    </div>
                  )}

                      <div
                        className="card-body card1"
                        ref={this.chatDiv}
                        onScroll={(e) => this.handleScroll(e)}
                      >
                        <ul
                          className="list-unstyled 
                    list-separated"
                        >
                          {messages && messages.length
                            ? messages.map((message, childIndex) => (
                                <div key={childIndex}>
                                  {message.messageFrom === "user" ||
                                  message.messageFrom === "customer" ? (
                                    <li className="list-separated-item">
                                      <div
                                        className="row 
                      row align-items-center botchat"
                                      >
                                        <div className="col col-auto">
                                          <span
                                            className="avatar avatar-md 
                    d-block usertextcolor 
                      userbackground1"
                                          >
                                            C
                                          </span>
                                        </div>
                                        <div className="col">
                                          <div>
                                            <span className="text-inherit">
                                              {message &&
                                              Array.isArray(message.media) &&
                                              message.media.length > 0 &&
                                              message.media[0].mimeType.split(
                                                "/",
                                              )[0] === "image" ? (
                                                // || message.media[0].mimeType === 'image/jpg'
                                                // || message.media[0].mimeType === 'image/png'
                                                <img
                                                  src={message.media[0].url}
                                                />
                                              ) : message &&
                                                Array.isArray(message.media) &&
                                                message.media.length > 0 ? (
                                                <a
                                                  target="_blank"
                                                  href={message.media[0].url}
                                                >
                                                  {
                                                    message.media[0]
                                                      .originalName
                                                  }{" "}
                                                </a>
                                              ) : (
                                                message.message
                                              )}
                                              <p>
                                                {this.formatDate(
                                                  message.createdAt,
                                                )}
                                              </p>
                                            </span>
                                          </div>
                                          <div></div>
                                        </div>
                                      </div>
                                    </li>
                                  ) : (
                                    <li className="list-separated-item">
                                      <div className="row row align-items-center">
                                        <div className="col">
                                          <div className="col01">
                                            <span className="text-inherit">
                                              {message &&
                                              Array.isArray(message.media) &&
                                              message.media.length > 0 &&
                                              message.media[0].mimeType.split(
                                                "/",
                                              )[0] === "image" ? (
                                                // || message.media[0].mimeType === 'image/jpg'
                                                // || message.media[0].mimeType === 'image/png'
                                                <img
                                                  src={message.media[0].url}
                                                />
                                              ) : message &&
                                                Array.isArray(message.media) &&
                                                message.media.length > 0 ? (
                                                <a
                                                  target="_blank"
                                                  href={message.media[0].url}
                                                >
                                                  {
                                                    message.media[0]
                                                      .originalName
                                                  }
                                                </a>
                                              ) : (
                                                message.message
                                              )}

                                              <p>
                                                {this.formatDate(
                                                  message.createdAt,
                                                )}
                                              </p>
                                            </span>
                                          </div>
                                        </div>

                                        <div className="col col-auto">
                                          <span
                                            className="avatar avatar-md 
                      d-block usertextcolor 
                        userbackground"
                                          >
                                            C
                                          </span>
                                        </div>
                                      </div>
                                    </li>
                                  )}
                                </div>
                              ))
                            : null}
                        </ul>
                      </div>
                      <div className="car18">
                        <div className="button-slider">
                          <Slider {...settings}>
                            {buttons &&
                              buttons.map((value, key) => {
                                let textValue = value.text;
                                return (
                                  <div key={key}>
                                    <h3
                                      title={textValue}
                                      onClick={() =>
                                        this.getButtonData(textValue)
                                      }
                                    >
                                      {value.name}
                                    </h3>
                                    {/* //enter value heare.. */}
                                  </div>
                                );
                              })}

                            {/* <div>
        <h3 onClick = {()=> this.getButtonData(2)}>Good Morning</h3>
      </div>
      <div>
        <h3 onClick = {()=> this.getButtonData(3)}>Help Message</h3>
      </div>
      <div>
        <h3>Welcome</h3>
      </div>
      <div>
        <h3>Change in TAT</h3>
      </div> */}
                            {/* <div>
        <h3>Report Unavailable</h3>
      </div> */}
                          </Slider>
                        </div>
                        <form id="chatForm">
                          <Form.Group label="">
                            <div className="form-group">
                              <textarea
                                className="form-control"
                                name="messageText"
                                placeholder="Type"
                                value={this.state.messageText}
                                onChange={(e) =>
                                  this.handleChange(e, "messageText")
                                }
                                onKeyDown={(e) =>
                                  this.handleChange(e, "messageText")
                                }
                                disabled={this.state.formDisabled}
                              ></textarea>
                            </div>
                          </Form.Group>

                          <div className="form-group">
                            <i className="fe fe-paperclip"></i>
                            <input
                              type="file"
                              disabled={this.state.formDisabled}
                              name="file"
                              id="file"
                              className="upload-file"
                              onChange={(e) => this.onChangeFile(e)}
                            />
                            <button
                              className={
                                "btn btn-primary pull-right" +
                                (this.state.teaBreakStatus
                                  ? " disablebutton"
                                  : " ")
                              }
                              disabled={
                                this.state.formDisabled ||
                                this.state.teaBreakStatus
                              }
                              onClick={(e) => this.emitMessage(e)}
                            >
                              {changeLanguage(
                                this.props.siteLanguage,
                                "send_message",
                              )}
                            </button>
                          </div>
                        </form>
                        <div className="pull-right dis-non">
                          <span
                            className="stamp stamp-md  bg-1 marginBottom10"
                            onClick={(e) => this.openPopup(e, "123")}
                          >
                            <i className="fe fe-dollar-sign"></i>
                          </span>
                          <span
                            className="stamp stamp-md  bg-2   marginBottom10"
                            onClick={(e) => this.openPopup(e, "123")}
                          >
                            <i className="fe fe-shopping-cart"></i>
                          </span>
                          <span className="stamp stamp-md bg-3   marginBottom10">
                            <i
                              className="fe fe-users"
                              onClick={(e) => this.openPopup(e, "123")}
                            ></i>
                          </span>
                          <span
                            className="stamp stamp-md bg-4   marginBottom10"
                            onClick={(e) => this.openPopup(e, "123")}
                          >
                            <i className="fe fe-message-square"></i>
                          </span>
                          <span
                            className="stamp stamp-md btn bg-5   marginBottom10"
                            onClick={(e) => this.openPopup(e, "123")}
                          >
                            <i className="fe fe-shopping-cart"></i>
                          </span>
                          <span
                            className="stamp stamp-md btn bg-6   marginBottom10"
                            onClick={(e) => this.openPopup(e, "123")}
                          >
                            <i className="fe fe-dollar-sign"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <ReadmorePopup
                  openPopup={this.state.openPopup}
                  onChange={this.closePopup}
                ></ReadmorePopup>
                <InfoPopup
                  openInfoPopup={this.state.openInfoPopup}
                  onChange={this.closeInfoPopup}
                ></InfoPopup>
              </Grid.Row>
            </div>
          </Page.Content>
          <ToastContainer autoClose={5000} position={"bottom-right"} />
        </SiteWrapperAdmin>

        <div style={this.styles.modalWrapper} className="BackgroundBlur">
          <div style={this.styles.modal}>
            <Card>
              <Card.Header>
                <Card.Title>Escalation Reason</Card.Title>
                <Card.Options>
                  <Button
                    color="secondary"
                    size="sm"
                    className="ml-2"
                    onClick={() => this.closeModal()}
                  >
                    Close
                  </Button>
                </Card.Options>
              </Card.Header>
              <Card.Body>
                {/* <Button  color="primary">Close</Button> */}
                <Form.FieldSet>
                  <Form.Group isRequired label={"Reason"}>
                    <Form.Input
                      name="name"
                      onChange={(e) => this.handleChangeEscalationReason(e)}
                      placeholder={"Reason"}
                      value={this.state.escalationReason}
                    />
                    {/* <label style={{ display: this.state.errors.name ? 'block' : 'none' }} className="error">{this.state.errors.name}</label> */}
                  </Form.Group>
                </Form.FieldSet>
                <Button
                  color="primary btn-block"
                  onClick={() => this.SendEscalationReason()}
                >
                  {" "}
                  Submit{" "}
                </Button>
              </Card.Body>
            </Card>
          </div>
        </div>

        {this.state.teaBreakStatus && (
          <div style={this.styles.TeaBreakWrapper}>
            <div style={this.styles.TeaBreakBackgroundBlur}></div>
            <button
              className="btn btn-primary"
              style={this.styles.TeaBreakButton}
              onClick={() => this.TeaBreakToggle()}
            >
              Tea Break off
            </button>
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
    activeBot: state.auth.activeBot,
    siteLanguage: state.auth.siteLanguage,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    logOut: () => {
      dispatch(authActions.authLogout());
    },
    setLang: (payload) => {
      dispatch(authActions.setLang(payload));
    },
  };
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AdminDashboard),
);
